export const getCardsData = (item) => {
    if (!item || (typeof item === 'object' && !Array.isArray(item) && Object.keys(item).length === 0)) {
        return [];
    }
    return [
        {
            id: 1,
            title: "Total orders",
            subTitle: "Today",
            icon: "user",
            iconBgColor: "warning",
            items: [
                `Orders: ${item?.today?.totalOrders}`,
                `Revenue:  ₹${item?.today?.totalRevenue}`,
            ]
        },
        {
            id: 2,
            title: "Total cash orders",
            subTitle: "Today",
            icon: "user-check",
            iconBgColor: "danger",
            items: [
                `Orders: ${item?.today?.cash.count}`,
                `Revenue:  ₹${item?.today?.cash.revenue}`,
            ]
        },
        {
            id: 3,
            title: "Total online orders",
            subTitle: "Today",
            icon: "calendar-check",
            iconBgColor: "warning",
            items: [
                `Orders: ${item?.today?.online.count}`,
                `Revenue:  ₹${item?.today?.online.revenue}`,
            ]
        },
        {
            id: 4,
            title: "Total orders",
            subTitle: "Last Month",
            icon: "calendar-day",
            iconBgColor: "success",
            items: [
                `Orders: ${item?.lastMonth?.totalOrders}`,
                `Revenue:  ₹${item?.lastMonth?.totalRevenue}`,
                `Pending Payment:  ${item?.lastMonth?.pendingPaymentsCount}, Amount:  ₹${item?.lastMonth?.pendingPaymentsAmount}`,
            ]
        }
    ];
}

export const getRestaurantCardsData = (item, feedback) => {
    if (
        !item ||
        (typeof item === "object" && !Array.isArray(item) && Object.keys(item).length === 0)
    ) {
        return [];
    }

    // First card: all branches total
    const cards = [
        {
            id: 1,
            title: "Total orders",
            subTitle: "Today",
            icon: "user",
            iconBgColor: "warning",
            items: [`Orders: ${item?.allBranchTotalOrders}`],
        },
    ];

    // Add one card for each branch
    if (Array.isArray(item.Summarydata)) {
        item?.Summarydata.forEach((branch, index) => {
            cards.push({
                id: index + 2, // unique id after the first one
                title: branch?.branchName,
                subTitle: "Today",
                icon: "user-check",
                iconBgColor: "danger",
                items: [`Orders: ${branch.totalOrders}`],
            });
        });
    }

    if (feedback) {
        const nextId = cards.length + 1;
        cards.push({
            id: nextId,
            title: 'Contact us',
            subTitle: "All",
            link:'/contact',
            icon: "feedback",
            iconBgColor: "info",
            items: [`Response: ${feedback}`],
        });
    }

    return cards;
};


